/**
 * Staff reorder for an artist bio. Saves only an artist-works- collection.
 * Arrows stay hidden for everyone else. A tag or genre filter blocks a move,
 * because the card beside this one may not be the stored neighbour.
 */
(function () {
  "use strict";

  var grid = document.querySelector(".masonry[data-artist-orderable='true']");
  if (!grid) return;
  var handle = grid.getAttribute("data-coll-handle") || "";
  if (handle.indexOf("artist-works-") !== 0) return;

  var pinKey = "artfolio-promote-pin";
  var staffUiKey = "artfolio-staff-ui";
  var endpoint = (window.theme && window.theme.promoteEndpoint) || "/apps/artfolio/promote";
  var saving = false;

  function hasStaffQuery() {
    try { return /(?:\?|&)staff=1(?:&|$)/.test(location.search || ""); } catch (err) { return false; }
  }
  function hasStoredStaff() {
    try {
      return !!(localStorage.getItem(pinKey) || sessionStorage.getItem(staffUiKey) === "1" || sessionStorage.getItem(pinKey));
    } catch (err) { return false; }
  }
  function hasAdminChrome() {
    var html = document.documentElement;
    if (html.classList.contains("has-shopify-admin-chrome") || html.classList.contains("shopify-design-mode")) return true;
    try {
      if (window.Shopify && (Shopify.designMode || Shopify.visualPreviewMode)) return true;
    } catch (err) {}
    return !!(
      document.getElementById("PBarNextFrameWrapper") ||
      document.getElementById("PreviewBarContainer") ||
      document.querySelector("iframe[id*='admin-bar'], iframe[id*='preview-bar'], .shopify-preview-bar")
    );
  }
  function isStaff() {
    var themeCfg = window.theme || {};
    if (themeCfg.isStaff || hasStaffQuery() || hasStoredStaff() || hasAdminChrome()) return true;
    try {
      var ref = String(document.referrer || "");
      if (/admin\.shopify\.com/i.test(ref) || /\/admin(\/|$|\?)/i.test(ref)) return true;
    } catch (err) {}
    return false;
  }
  function readPin() {
    try { return localStorage.getItem(pinKey) || sessionStorage.getItem(pinKey) || ""; } catch (err) { return ""; }
  }
  function writePin(value) {
    try {
      localStorage.setItem(pinKey, value);
      sessionStorage.setItem(pinKey, value);
      localStorage.setItem(staffUiKey, "1");
    } catch (err) {}
  }
  function pinInput() {
    return document.querySelector("[data-coll-hero-pin-input]");
  }
  function currentPin() {
    var input = pinInput();
    var typed = input && input.value ? String(input.value).trim() : "";
    if (typed) return typed;
    return readPin();
  }
  function revealPin() {
    var wrap = document.querySelector("[data-coll-hero-pin]");
    if (wrap) {
      wrap.hidden = false;
      wrap.removeAttribute("hidden");
    }
    var input = pinInput();
    if (input) input.focus();
  }

  if (!isStaff()) return;
  try { localStorage.setItem(staffUiKey, "1"); } catch (err) {}
  grid.classList.add("is-staff-order");
  Array.prototype.forEach.call(grid.querySelectorAll("[data-coll-order]"), function (el) {
    el.hidden = false;
    el.removeAttribute("hidden");
  });

  function filterActive() {
    var chips = document.querySelectorAll(".artist-chip.is-active");
    for (var i = 0; i < chips.length; i++) {
      var tag = chips[i].getAttribute("data-artist-tag");
      var genre = chips[i].getAttribute("data-artist-genre");
      if (chips[i].hasAttribute("data-artist-tag") && tag) return true;
      if (chips[i].hasAttribute("data-artist-genre") && genre) return true;
    }
    return false;
  }

  function lastPos() {
    return Number(grid.getAttribute("data-coll-count") || "0") - 1;
  }

  function syncEnds(card) {
    if (!card) return;
    var pos = Number(card.getAttribute("data-coll-pos"));
    var earlier = card.querySelector('[data-coll-move="earlier"]');
    var later = card.querySelector('[data-coll-move="later"]');
    if (earlier) earlier.disabled = !(pos > 0);
    if (later) later.disabled = !(pos < lastPos());
  }

  function neighbor(card, direction) {
    var el = direction === "earlier" ? card.previousElementSibling : card.nextElementSibling;
    while (el && !el.classList.contains("mcard")) {
      el = direction === "earlier" ? el.previousElementSibling : el.nextElementSibling;
    }
    return el;
  }

  function lockMoves() {
    saving = true;
    grid.classList.add("is-order-locked");
    Array.prototype.forEach.call(grid.querySelectorAll("[data-coll-move]"), function (button) {
      button.disabled = true;
    });
  }

  function unlockMoves() {
    saving = false;
    grid.classList.remove("is-order-locked");
    Array.prototype.forEach.call(grid.querySelectorAll(".mcard"), function (card) {
      card.classList.remove("is-order-saving");
      syncEnds(card);
    });
  }

  function moveDom(card, direction) {
    var other = neighbor(card, direction);
    if (!other) return null;
    var snap = {
      card: card,
      other: other,
      direction: direction,
      cardPos: card.getAttribute("data-coll-pos"),
      otherPos: other.getAttribute("data-coll-pos")
    };
    if (direction === "earlier") grid.insertBefore(card, other);
    else grid.insertBefore(card, other.nextSibling);
    card.setAttribute("data-coll-pos", snap.otherPos);
    other.setAttribute("data-coll-pos", snap.cardPos);
    syncEnds(card);
    syncEnds(other);
    return snap;
  }

  function restore(snap) {
    if (!snap || !snap.card || !snap.other) return;
    if (snap.direction === "earlier") grid.insertBefore(snap.card, snap.other.nextSibling);
    else grid.insertBefore(snap.card, snap.other);
    snap.card.setAttribute("data-coll-pos", snap.cardPos);
    snap.other.setAttribute("data-coll-pos", snap.otherPos);
    syncEnds(snap.card);
    syncEnds(snap.other);
  }

  function postJson(pin, payload) {
    return fetch(endpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "content-type": "application/json",
        accept: "application/json",
        "X-Promote-Pin": pin
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.text().then(function (text) {
        var body = {};
        try { body = text ? JSON.parse(text) : {}; } catch (err) { body = {}; }
        if (!body.error && !res.ok) body.error = "Could not save the new order (" + res.status + ").";
        return { ok: res.ok && body && body.ok, body: body };
      });
    });
  }

  function postMove(pin, card, direction) {
    return postJson(pin, {
      op: "reorder_artist",
      pin: pin,
      collectionId: grid.getAttribute("data-coll-id") || "",
      handle: handle,
      productId: card.getAttribute("data-product-id") || "",
      direction: direction
    }).then(function (result) {
      if (!(result.body && result.body.pending && result.body.jobId)) return result;
      var attempts = 0;
      function poll() {
        attempts += 1;
        return postJson(pin, { op: "reorder_job", pin: pin, jobId: result.body.jobId }).then(function (check) {
          if (!check.ok || (check.body && check.body.done) || attempts >= 40) {
            if (check.ok && check.body && !check.body.done) {
              return { ok: false, body: { error: "Could not save the new order." } };
            }
            return check;
          }
          return new Promise(function (resolve) {
            setTimeout(function () { resolve(poll()); }, 500);
          });
        });
      }
      return poll();
    });
  }

  function failMove(card, snap, message) {
    if (snap) restore(snap);
    if (card) card.classList.remove("is-order-saving");
    unlockMoves();
    if (message) window.alert(message);
  }

  grid.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-coll-move]");
    if (!btn || !grid.contains(btn)) return;
    event.preventDefault();
    event.stopPropagation();
    if (saving || btn.disabled || filterActive()) return;
    var card = btn.closest(".mcard");
    if (!card) return;
    var pin = currentPin();
    if (!pin) {
      revealPin();
      return;
    }
    var direction = btn.getAttribute("data-coll-move") || "";
    lockMoves();
    var snap = moveDom(card, direction);
    lockMoves();
    card.classList.add("is-order-saving");
    postMove(pin, card, direction).then(function (result) {
      if (result.body && result.body.error === "unauthorized") {
        writePin("");
        failMove(card, snap, "");
        revealPin();
        return;
      }
      if (!result.ok) {
        failMove(card, snap, (result.body && result.body.error) || "Could not save the new order.");
        return;
      }
      writePin(pin);
      if (!snap) {
        window.location.reload();
        return;
      }
      unlockMoves();
    }).catch(function () {
      failMove(card, snap, "Could not save the new order.");
    });
  });
})();
